"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSpecialActionKeyOfOtherTabsActions = "$$randomKey$$";
exports.defaultSpecialItemNameOfOtherTabsActions = "$$lastAction$$";
var FakeStorage = /** @class */ (function () {
    function FakeStorage() {
        var _this = this;
        this.data = {};
        this.getItem = function (key) {
            if (_this.data[key] !== undefined) {
                return JSON.stringify(_this.data[key]);
            }
            return null;
        };
        this.removeItem = function (key) {
            delete _this.data[key];
        };
        this.setItem = function (key, value) {
            _this.data[key] = value;
        };
    }
    return FakeStorage;
}());
exports.FakeStorage = FakeStorage;
function loadFromStorage(_a) {
    var storage = _a.storage, key = _a.key, validateWholeData = _a.validateWholeData, filter = _a.filter;
    var value = storage.getItem(key);
    if (value) {
        try {
            var items = JSON.parse(value);
            var originalItemsNum = Object.keys(items).length;
            var validatedItems = (validateWholeData
                ? validateWholeData(items)
                : items);
            var filteredItems = filter
                ? {}
                : validatedItems;
            if (filter) {
                var keys = Object.keys(validatedItems);
                for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                    var key_1 = keys_1[_i];
                    var instance = validatedItems[key_1];
                    if (filter(instance)) {
                        filteredItems[key_1] = instance;
                    }
                }
            }
            storage.setItem(key, JSON.stringify(filteredItems));
            return {
                data: filteredItems,
                loadedAll: originalItemsNum === Object.keys(filteredItems).length,
            };
        }
        catch (e) {
            storage.removeItem(key);
            return { data: {}, loadedAll: false };
        }
    }
    return { data: {}, loadedAll: false };
}
exports.loadFromStorage = loadFromStorage;
exports.filterByLoadTime = function (maxTimeToPass, minLoadTime, leaveUnknownLoadTimes) {
    if (minLoadTime === void 0) { minLoadTime = -1; }
    if (leaveUnknownLoadTimes === void 0) { leaveUnknownLoadTimes = false; }
    if (minLoadTime >= 0 && typeof minLoadTime !== "number") {
        minLoadTime = new Date(minLoadTime).getTime();
    }
    return function (data) {
        if (!data.loadTime)
            return leaveUnknownLoadTimes;
        var loadTime = new Date(data.loadTime);
        if (minLoadTime !== -1) {
            if (minLoadTime > loadTime.getTime()) {
                return false;
            }
        }
        return Date.now() - loadTime.getTime() <= maxTimeToPass;
    };
};
var reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
function jsonDateParser(key, value) {
    if (typeof value === "string") {
        var a = reISO.exec(value);
        if (a)
            return new Date(value);
    }
    return value;
}
exports.jsonDateParser = jsonDateParser;
